import beActivateTagsTrial from 'actions/billing/beActivateTagsTrial.action';
import beGetBillingDetails from 'actions/billing/beGetBillingDetails.action';
import beGetTagsTrial from 'actions/billing/beGetTagsTrial.action';
import beUpgradePlan from 'actions/billing/beUpgradePlan.action';
import alwaysSame from 'utils/functions/nullary/alwaysSame.util';
import C from 'utils/values/constant.util';

import {
  BUY_DAC_FAILURE,
  BUY_DAC_REQUEST,
  BUY_DAC_SUCCESS,
  CREATE_TOKEN_SUCCESS,
  GET_CUSTOMER_INVOICES_FAILURE,
  GET_CUSTOMER_INVOICES_REQUEST,
  GET_CUSTOMER_INVOICES_SUCCESS,
  GET_PLANS_REQUEST,
  GET_PLANS_SUCCESS,
  GET_STRIPE_CUSTOMER_FAILURE,
  GET_STRIPE_CUSTOMER_REQUEST,
  GET_STRIPE_CUSTOMER_SUCCESS,
  GET_TOKEN_SUCCESS,
  UPDATE_STRIPE_TOKEN_FAILURE,
  UPDATE_STRIPE_TOKEN_REQUEST,
  UPDATE_STRIPE_TOKEN_SUCCESS,
} from 'settings/billing/actions';

import asObject from '../utils/objects/asObject.util';

const DEFAULT = C({
  errorMessage: '',
  isFetching: false,
  stripeCustomerData: {},
  invoices: [],
  stripeCardDetails: {},
  stripeToken: {},
  coupon: {},
  billingPlan: [],
  trialResponseText: '',
});

const MAP = Object.freeze({
  [GET_STRIPE_CUSTOMER_REQUEST]: (state) => ({ ...state, isFetching: true }),
  [GET_STRIPE_CUSTOMER_SUCCESS]: (state, { response }) => ({
    ...state,
    isFetching: false,
    stripeCustomerData: JSON.parse(JSON.stringify(response)),
    errorMessage: '',
  }),
  [GET_STRIPE_CUSTOMER_FAILURE]: (state, { errorMessage }) => ({ ...state, isFetching: false, errorMessage }),

  [GET_CUSTOMER_INVOICES_REQUEST]: (state) => ({ ...state, isFetching: true }),
  [GET_CUSTOMER_INVOICES_SUCCESS]: (state, { response }) => ({
    ...state,
    isFetching: false,
    invoices: response,
    errorMessage: '',
  }),
  [GET_CUSTOMER_INVOICES_FAILURE]: (state, { errorMessage }) => ({ ...state, isFetching: false, errorMessage }),

  [GET_PLANS_REQUEST]: (state) => ({ ...state, isFetching: true }),
  [GET_PLANS_SUCCESS]: (state, { response }) => ({ ...state, isFetching: false, billingPlan: response }),

  [beUpgradePlan.AT.init]: (state) => ({ ...state, isFetching: true }),
  [beUpgradePlan.AT.pass]: (state) => ({ ...state, isFetching: false }),
  [beUpgradePlan.AT.fail]: (state) => ({ ...state }),

  [BUY_DAC_REQUEST]: (state) => ({ ...state, isFetching: true }),
  [BUY_DAC_SUCCESS]: (state) => ({ ...state, isFetching: false }),
  [BUY_DAC_FAILURE]: (state) => ({ ...state }),

  [beGetTagsTrial.AT.init]: (state) => ({ ...state }),
  [beGetTagsTrial.AT.pass]: (state, { response }) => ({ ...state, trialResponseText: response.all_features[0] }),
  [beGetTagsTrial.AT.fail]: (state, { errorMessage }) => ({ ...state, errorMessage }),

  [beActivateTagsTrial.AT.init]: (state) => ({ ...state }),
  [beActivateTagsTrial.AT.pass]: (state) => ({ ...state }),
  [beActivateTagsTrial.AT.fail]: (state, { errorMessage }) => ({ ...state, errorMessage }),

  [CREATE_TOKEN_SUCCESS]: (state, { stripetoken }) => ({
    ...state,
    isFetching: false,
    stripeToken: stripetoken,
    errorMessage: '',
  }),
  [GET_TOKEN_SUCCESS]: (state) => ({ ...state, stripeToken: state.stripeToken, errorMessage: '' }),

  [UPDATE_STRIPE_TOKEN_REQUEST]: (state) => ({ ...state, isFetching: true }),
  [UPDATE_STRIPE_TOKEN_SUCCESS]: (state, data) => ({
    ...state,
    isFetching: false,
    stripeToken: data.stripetoken,
    errorMessage: '',
  }),
  [UPDATE_STRIPE_TOKEN_FAILURE]: (state, { errorMessage }) => ({ ...state, isFetching: false, errorMessage }),

  [beGetBillingDetails.AT.pass]: (state, { result }) => ({
    ...state,
    isFetching: false,
    stripeCardDetails: result.json,
  }),
});

const billingReducer = (state, action) =>
  (MAP[action && action.type] || alwaysSame)(state || { ...DEFAULT }, asObject(action));

// noinspection JSUnusedGlobalSymbols
export default billingReducer;
